module.exports = __webpack_public_path__ + "static/media/foodndrinks_fishing_marker.7dd5275a.svg";